import React, { Component } from 'react';
// import Icon from '../icon/icon';
import '../css/Modal.css';
const $ = window.$;

class Modal extends Component {

    componentDidMount() {
        $('body').addClass("scroll-bar-disable");
    }

    componentWillUnmount() {
        $('body').removeClass("scroll-bar-disable");
    }

    render() {
        const { title, iconName, children, openModal, closeModal } = this.props;
        console.log(this.props)
        return (
            <div>
                {(openModal) ?
                    <div className="modals-container">
                        <div className="modals-curtain"></div>
                        <div className="modals-content">
                            <div className="card">
                                <div className="card-title">
                                {iconName ?  
                                    <div className="card-icon"></div>
                                :null}
                                    <div className="card-title-text">
                                        {title}
                                    </div>
                                    <i className="fas fa-times modals-close" onClick={closeModal}></i>
                                </div>
                                <div className="card-content">{children}</div>
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

export default Modal;